import { render, staticRenderFns } from "./ProductsCarousel.vue?vue&type=template&id=1657887a&scoped=true&"
import script from "./ProductsCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCarousel.vue?vue&type=style&index=0&id=1657887a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1657887a",
  null
  
)

export default component.exports